import { ChangeDetectionStrategy, Component, inject, signal, resource, input } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { AuthService } from "@shared/services/auth.service";
import { EventsService } from "@shared/services/events.service";
import { CommonModule } from "@angular/common";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-header",
  templateUrl: "./header.html",
  styleUrl: "./header.css",
  host: {
    'class': 'd-block'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, CommonModule],
})
export class HeaderComponent {
  protected readonly isMobileMenuOpen = signal(false);
  protected readonly authService = inject(AuthService);
  protected readonly eventsService = inject(EventsService);
  private readonly router = inject(Router);

  /** Staff app origin for the cross-host "Panou Staff" link (empty in dev/e2e
   *  → the link is hidden). The staff app is a separate SPA on another host, so
   *  it must be a full-page navigation, not an in-app routerLink. (#473) */
  protected readonly staffUrl = environment.staffUrl;

  protected readonly upcomingEvents = resource({
    loader: () => firstValueFrom(this.eventsService.getUpcomingEvents())
  });

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(open => !open);
  }

  logout() {
    this.isMobileMenuOpen.set(false);
    this.authService.logout();
  }

  closeMenus() {
    this.isMobileMenuOpen.set(false);
  }

  goToRegistration() {
    // Only the unauthenticated user icon binds this (see header.html), so it
    // always sends a guest to the login/landing page.
    this.router.navigate(["/"]);
  }
}
